<template>
  <div class="recharge">
    <Breadcrumb></Breadcrumb>
    <div class="recharge-chunk">
      <div class="common-limit line-height-40">
        <el-card v-if="!showForm" class="account" style="margin: 0 0 12px 0">
          <div slot="header">请选择认证类型</div>
          <div class="message tc">
            <div class="tc">
              <h3 class="title">请选择认证类型</h3>
              <p class="gray" style="line-height: 32px">
                实名认证信息对您的账号和资金安全很重要，请按实际情况进行实名认证。
              </p>
              <div
                class="flex-row flex-x-center"
                style="margin-top: 40px; margin-bottom: 249px"
              >
                <div
                  class="verify-box flex-col flex-x-center flex-y-center"
                  style="margin-right: 100px"
                >
                  <p class="iconbox"><i class="el-icon-user"></i></p>
                  <p class="name">个人实名认证</p>
                  <p class="desc gray">及时认证，无需等待</p>
                  <a class="main-btn-b button" @click="handleAuth('01')"
                    >去认证</a
                  >
                </div>
                <div class="verify-box flex-col flex-x-center flex-y-center">
                  <p class="iconbox"><i class="el-icon-office-building"></i></p>
                  <p class="name">企业实名认证</p>
                  <p class="desc gray">认证审核时间为1-5个工作日</p>
                  <a class="main-btn-b button" @click="handleAuth('02')"
                    >去认证</a
                  >
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card
          v-if="form.authType == '01' && showForm"
          class="account"
          style="margin: 0 0 12px 0"
        >
          <div slot="header">个人实名认证</div>
          <div class="message">
            <div>
              <div class="real-name-content">
                <div class="tc" style="max-width: 930px">
                  <h1 class="title">欢迎您进行平台定制实名认证</h1>
                  <p class="explain">
                    平台定制技术加密，保障您的账号信息安全；请填写以下个人信息，提交认证
                  </p>
                </div>

                <form class="form-list">
                  <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-width="112px"
                  >
                    <el-form-item label="真实姓名：" prop="legalName">
                      <el-input
                        size="small"
                        v-model="form.legalName"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号：" prop="legalId">
                      <el-input size="small" v-model="form.legalId"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码：" prop="legalPhone">
                      <el-input
                        size="small"
                        readonly
                        v-model="form.legalPhone"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="短信验证码：" prop="remark">
                      <el-input size="small" v-model="form.remark">
                        <template slot="append"
                          ><span
                            v-if="!isSend"
                            style="cursor: pointer"
                            @click="handleSendMessage"
                            >发送验证码</span
                          ><span v-if="isSend">{{ remain }} s</span></template
                        >
                      </el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button size="small" type="primary" @click="submitForm"
                        >提交</el-button
                      >
                    </el-form-item>
                    <el-form-item prop="code" label="">
                      <el-checkbox v-model="checked"> </el-checkbox>
                      <span style="margin: 0 0 0 16px"
                        >本人承诺：
                        上述所填信息均真实、合法、有效，平台定制有权自行或委托第三方审查本人提供的相关信息；
                        因该信息存在虚假、不实或违反法律法规而引发的一切责任均由本人自行承担。
                      </span>
                    </el-form-item>
                  </el-form>
                </form>
              </div>
            </div>
          </div>
        </el-card>
        <el-card
          v-if="form.authType == '02' && showForm"
          class="account"
          style="margin: 0 0 12px 0"
        >
          <div slot="header">企业实名认证</div>
          <div class="message">
            <div>
              <div class="real-name-content">
                <div class="tc" style="max-width: 930px">
                  <h1 class="title">欢迎您进行平台定制实名认证</h1>
                  <p class="explain">
                    平台定制技术加密，保障您的账号信息安全；请填写以下企业信息，提交认证
                  </p>
                </div>
                <form class="form-list">
                  <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-width="132px"
                  >
                    <div
                      style="
                        margin: 0 0 16px 29px;
                        font-size: 14px;
                        font-weight: bold;
                      "
                    >
                      企业信息
                    </div>
                    <el-form-item label="企业名称：" prop="enterprise">
                      <el-input
                        size="small"
                        v-model="form.enterprise"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="统一信用代码："
                      prop="uniformCreditCode"
                    >
                      <el-input
                        size="small"
                        v-model="form.uniformCreditCode"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照附件：" prop="attachId">
                      <el-upload
                        ref="upload"
                        action="#"
                        list-type="picture-card"
                        :file-list="fileList"
                        :auto-upload="false"
                        :on-change="handleChange"
                        :limit="1"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                    <div
                      style="
                        margin: 0 0 16px 29px;
                        font-size: 14px;
                        font-weight: bold;
                      "
                    >
                      法人信息
                    </div>
                    <el-form-item label="法人姓名：" prop="legalName">
                      <el-input
                        size="small"
                        v-model="form.legalName"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="法人身份证号：" prop="legalId">
                      <el-input size="small" v-model="form.legalId"></el-input>
                    </el-form-item>
                    <el-form-item label="法人手机号码：" prop="legalPhone">
                      <el-input
                        size="small"
                        v-model="form.legalPhone"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="短信验证码：" prop="remark">
                      <el-input size="small" v-model="form.remark">
                        <template slot="append"
                          ><span
                            v-if="!isSend"
                            style="cursor: pointer"
                            @click="handleSendMessage"
                            >发送验证码</span
                          ><span v-if="isSend">{{ remain }} s</span></template
                        >
                      </el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button size="small" type="primary" @click="submitForm"
                        >提交</el-button
                      >
                    </el-form-item>
                    <el-form-item prop="code" label="">
                      <el-checkbox v-model="checked"> </el-checkbox>
                      <span style="margin: 0 0 0 16px"
                        >本人承诺：
                        上述所填信息均真实、合法、有效，平台定制有权自行或委托第三方审查本人提供的相关信息；
                        因该信息存在虚假、不实或违反法律法规而引发的一切责任均由本人自行承担。
                      </span>
                    </el-form-item>
                  </el-form>
                </form>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ElRow from "element-ui/packages/row/src/row"
import Breadcrumb from "@/components/common/Breadcrumb"
// import {
//   alipayPc,
//   getUserProfile,
//   saveUserFund,
// } from '@/api/business/moneyManger'

import {
  getUserProfile,
  saveUserFund,
  sendUserAuthCodeSms,
  addAuth,
} from "@/api/system/user"
import { listRecharge, saveRecharge } from "@/api/system/money"
import { uploadFile } from "@/api/upload/upload"
import { getConfigKey } from "@/api/system/config"

//图标变彩色的位置
const m = new Map()
//第一行
m.set("0", ["-60px", "-7px"]) //..键是数值

export default {
  components: { ElRow, Breadcrumb },
  data: function () {
    return {
      form: {
        remark: "",
        legalId: "",
        legalName: "",
        legalPhone: "",
        enterprise: "",
        uniformCreditCode: "",
        attachId: "",
        authType: "02",
      },
      showForm: false,
      user: {},
      loading: false,
      isSend: false,
      remain: 60,
      checked: false,
      rules: {
        legalName: [
          { required: true, message: "请输入真实姓名", trigger: "change" },
        ],
        enterprise: [
          { required: true, message: "请输入企业名称", trigger: "change" },
        ],
        uniformCreditCode: [
          { required: true, message: "请输入统一信用代码", trigger: "change" },
        ],
        legalId: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        remark: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        attachId: [
          { required: true, message: "请上传营业执照附件", trigger: "blur" },
        ],
        legalPhone: [
          { required: true, message: "请输入法人手机号码", trigger: "blur" },
        ],
      },
      fileList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    //查询当前账户余额
    this.getUser()
  },

  methods: {
    //查询当前账户余额
    getUser() {
      getUserProfile({}).then((response) => {
        this.user = response.user
        this.form.legalPhone = this.user.phoneNumber
      })
    },
    handleChange(file, fileList) {
      this.fileList = fileList
      if (fileList.length > 0) {
        this.form.attachId = "1"
      } else {
        this.form.attachId
      }
    },
    // 保存文件
    async handleSaveFile() {
      var _self = this
      _self.uploadFlag = false
      _self.imgUrl = ""
      if (this.fileList.length > 0) {
        const file = this.fileList[0]
        if (!file.raw) {
          _self.uploadFlag = true
          _self.imgUrl = file.url
          return
        }
        const { uploadFlag, fileUrl } = await uploadFile(file)
        _self.uploadFlag = uploadFlag
        _self.imgUrl = fileUrl
        this.form.attachId = fileUrl
      }
    },

    //充值
    async submitForm() {
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      try {
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            try {
              let form = this._.clone(this.form)
              if (!this.checked) {
                this.isSubmit = false
                this.msgError("请勾选协议")
                return
              }
              if (form.authType == "02") {
                await this.handleSaveFile()
              } else {
                form.enterprise = form.legalName
                form.legalName = ""
              }

              let res = await addAuth(
                this._.pick(
                  form,
                  "legalName",
                  "legalId",
                  "legalPhone",
                  "enterprise",
                  "uniformCreditCode",
                  "attachId",
                  "authType",
                  "remark"
                )
              )
              if (res.code === 200) {
                this.msgSuccess("提交成功")
                this.$router.push({
                  path: "/system/account/userInfo",
                })
                this.isSubmit = false
              } else {
                this.msgError("提交失败")
                this.isSubmit = false
              }
            } catch (error) {
              this.isSubmit = false
            }
          } else {
            this.isSubmit = false
            return false
          }
        })
      } catch (error) {
        this.isSubmit = false
      } finally {
      }
    },
    async handleSendMessage() {
      try {
        if (this.isSend) {
          return
        }
        let _self = this

        let result = await sendUserAuthCodeSms({
          legalPhone: this.form.legalPhone,
          authType: this.form.authType,
        })
        if (result.code == 200) {
          let timer = window.setInterval(() => {
            _self.remain = Number(_self.remain) - 1
            if (this.remain == 0) {
              window.clearInterval(timer)
              _self.remain = 60
              this.isSend = false
            }
          }, 1000)
          this.isSend = true
          this.msgSuccess("短信发送成功")
        } else {
          this.getCode()
        }
      } catch (error) {}
    },
    handleAuth(authType) {
      if (this.user.authStatus && this.user.authStatus == "03") {
        this.msgSuccess("您已认证，无需再次申请认证")
        return
      }
      this.showForm = true
      this.form.authType = authType
    },
  },

  mounted() {},
}
</script>

<style scoped>
@import "../../../assets/css/iconfont/iconfont.css";

.title {
  font-size: 24px;
  line-height: 38px;
  font-weight: 600;
  color: rgba(89, 90, 90, 1);
  padding-top: 40px;
}
.gray {
  color: rgb(153, 153, 153) !important;
}
.flex-wrap {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.flex-x-center {
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.flex-x-end {
  -webkit-box-pack: end;
  -moz-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.flex-y-center {
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.flex-y-end {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}
.flex-x-full {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flex-inline-center {
  display: -webkit-inline-box;
  display: -moz-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.align-center {
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.flex-1 {
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.verify-box {
  width: 320px;
  height: 300px;
  background: #fff;
  box-shadow: 1px 2px 8px 0px rgb(0 0 0 / 10%);
}
.verify-box .iconbox {
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: rgba(246, 246, 246, 1);
  border-radius: 50%;
}
.verify-box .name {
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  color: rgba(89, 90, 90, 1);
  margin-top: 20px;
}
.verify-box .desc {
  margin-top: 5px;
}
.main-btn-b,
.main-btn-light {
  border-radius: 4px;
  background-color: #4934b2;
  color: #fff;
  display: inline-block;
  padding: 4px 16px;
  border: 1px solid #4934b2;
  line-height: 1.5;
  cursor: pointer;
}
.verify-box .button {
  width: 120px;
  margin-top: 30px;
}
.flex-x-center {
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.flex-col {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.tc {
  text-align: center !important;
}

.flex-row {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.verify-box .iconbox {
  font-size: 40px;
  color: #4934b2;
}
.real-name-content .explain {
  max-width: 1190px;
  font-size: 12px;
  line-height: 32px;
  color: #999999;
  text-align: center;
}
.real-name-content .form-list {
  color: #595a5a;
  margin-top: 30px;
  max-width: 60%;
}
</style>
